import React from 'react';
import { IconMinus, IconPlus } from '@planne-software/uni/icons';
import { IconButton } from '@planne-software/uni';
import { QuantityControls, QuantityLabel, QuantitySection, QuantityValueBox, QuantityValueText } from './styles';

export type QuantitySelectorProps = {
  value: number;
  label: string;
  decrementAriaLabel: string;
  incrementAriaLabel: string;
  onDecrement: VoidFunction;
  onIncrement: VoidFunction;
  incrementDisabled?: boolean;
  decrementDisabled?: boolean;
};

export const QuantitySelector = (props: QuantitySelectorProps) => {
  const {
    value,
    label,
    decrementAriaLabel,
    incrementAriaLabel,
    onDecrement,
    onIncrement,
    incrementDisabled = false,
    decrementDisabled = false,
  } = props;

  return (
    <QuantitySection>
      <QuantityLabel>{label}</QuantityLabel>
      <QuantityControls direction='row'>
        <IconButton
          type='button'
          variant='outlined'
          color='neutral'
          size='xs'
          aria-label={decrementAriaLabel}
          disabled={decrementDisabled}
          onClick={onDecrement}
        >
          <IconMinus size={16} stroke={2} />
        </IconButton>
        <QuantityValueBox>
          <QuantityValueText>{value}</QuantityValueText>
        </QuantityValueBox>
        <IconButton
          type='button'
          variant='outlined'
          color='primary'
          size='xs'
          disabled={incrementDisabled}
          aria-label={incrementAriaLabel}
          onClick={onIncrement}
        >
          <IconPlus size={16} stroke={2} />
        </IconButton>
      </QuantityControls>
    </QuantitySection>
  );
};
